import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment to test minor making the swatches on product tiles interactable on select and hover states.
 * https://www.notion.so/faire/Product-Option-First-Tiles-1e02efb5c25a801e841ad6191747bf42?pvs=4#1e12efb5c25a800cb74fe82ec017af98
 * https://www.figma.com/design/3uLk8iNLX0yKRlG3nnNkv7/Tile-swatches?node-id=6562-73260&t=YP87Cxk3UU1OxbSK-1
 */
export const INTERACTABLE_TILE_SWATCHES_XP_250528 =
  'INTERACTABLE_TILE_SWATCHES_XP_250528' as SettingConst<
    'INTERACTABLE_TILE_SWATCHES_XP_250528',
    boolean,
    'RETAILER'
  >;
